import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input } from 'reactstrap';
import { useCreateHelp } from 'api/helps/service';
import { getActiveColorStyle } from '../../utils/colorUtils';
import Select from "components/Select";

/**
 * NavbarHelp component for the help modal in the navbar
 * @param {boolean} isOpen - Whether the modal is open
 * @param {function} onToggle - Toggle handler for the modal
 * @param {string} activeColor - The active theme color
 */
const NavbarHelp = ({
    isOpen,
    onToggle,
    activeColor,
    isLightTheme,
    toolbarIconFontSize,
    toolbarIconColor,
    toolbarIconColorActive,
    hideToolbarTrigger = false,
}) => {
    const [formData, setFormData] = useState({
        type: 'help',
        priority: 'medium',
        note: ''
    });

    const { mutate: createHelp, isLoading } = useCreateHelp();
    const activeStyle = getActiveColorStyle(activeColor);

    const typeOptions = [
        { value: 'bug', label: 'Bug' },
        { value: 'help', label: 'Help' },
        { value: 'info', label: 'Info' },
        { value: 'question', label: 'Question' }
    ];

    const priorityOptions = [
        { value: 'low', label: 'Low' },
        { value: 'medium', label: 'Medium' },
        { value: 'high', label: 'High' },
        { value: 'critical', label: 'Critical' }
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = () => {
        createHelp(formData, {
            onSuccess: () => {
                onToggle(false);
                setFormData({
                    type: 'help',
                    priority: 'medium',
                    note: ''
                });
            }
        });
    };

    return (
        <>
            {!hideToolbarTrigger && (
            <div className="settings" style={{ display: 'inline-block' }}>
                <a
                    href="#pablo"
                    onClick={(e) => {
                        e.preventDefault();
                        onToggle(!isOpen);
                    }}
                    style={{
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '40px',
                        height: '40px',
                        backgroundColor: isLightTheme
                            ? isOpen
                                ? 'rgba(0, 0, 0, 0.08)'
                                : 'transparent'
                            : isOpen
                                ? 'rgba(255, 255, 255, 0.15)'
                                : 'transparent',
                        transition: 'all 0.2s ease'
                    }}
                >
                    <i
                        className="tim-icons icon-support-17"
                        style={{
                            fontSize: toolbarIconFontSize ?? '1.5rem',
                            color:
                                toolbarIconColor != null
                                    ? isOpen
                                        ? toolbarIconColorActive ?? "#1d8cf8"
                                        : toolbarIconColor
                                    : isOpen
                                      ? "#1d8cf8"
                                      : "white",
                            verticalAlign: 'middle',
                        }}
                    />
                </a>
            </div>
            )}

            <Modal isOpen={isOpen} toggle={() => onToggle(!isOpen)} modalClassName={!isLightTheme ? "modal-black" : ""}>
                <div className="modal-header justify-content-center" style={{
                    backgroundImage: activeStyle.backgroundImage,
                    color: 'white',
                    padding: '1.5rem',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '15px'
                }}>
                    <button
                        aria-hidden={true}
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => onToggle(!isOpen)}
                        style={{ color: 'white', opacity: 1, textShadow: 'none', position: 'absolute', right: '15px', top: '15px' }}
                    >
                        <i className="tim-icons icon-simple-remove" />
                    </button>
                    <div style={{
                        width: '50px',
                        height: '50px',
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <i className="tim-icons icon-support-17" style={{ fontSize: '24px' }} />
                    </div>
                    <h4 className="title title-up" style={{ color: 'white', margin: 0, fontWeight: 600 }}>Help Request</h4>
                </div>
                <ModalBody>
                    <Form>
                        <div style={{ display: "flex", gap: "20px" }}>
                            <FormGroup style={{ flex: 1 }}>
                                <Label for="type">Type</Label>
                                <Select
                                    activeColor={activeColor}
                                    className="react-select"
                                    placeholder="Select Type"
                                    name="type"
                                    value={typeOptions.find(opt => opt.value === formData.type)}
                                    onChange={(option) => {
                                        setFormData(prev => ({ ...prev, type: option?.value || 'help' }));
                                    }}
                                    options={typeOptions}
                                />
                            </FormGroup>
                            <FormGroup style={{ flex: 1 }}>
                                <Label for="priority">Priority</Label>
                                <Select
                                    activeColor={activeColor}
                                    className="react-select"
                                    placeholder="Select Priority"
                                    name="priority"
                                    value={priorityOptions.find(opt => opt.value === formData.priority)}
                                    onChange={(option) => {
                                        setFormData(prev => ({ ...prev, priority: option?.value || 'medium' }));
                                    }}
                                    options={priorityOptions}
                                />
                            </FormGroup>
                        </div>
                        <FormGroup>
                            <Label for="note">Note</Label>
                            <Input type="textarea" name="note" id="note" value={formData.note} onChange={handleInputChange} rows="5" />
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => onToggle(!isOpen)}>Cancel</Button>
                    <Button
                        style={{
                            backgroundImage: activeStyle.backgroundImage,
                            borderColor: activeStyle.borderColor,
                            color: 'white'
                        }}
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Sending...' : 'Send'}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};
export default NavbarHelp;
